import { AlertTriangle } from "lucide-react";

// Sole shortage for one cutting line (w = { p, list } from Cutting.soleWarningsFor)
export const SoleWarning = ({ w, testId }) => {
  if (!w || !w.list.length) return null;
  return (
    <div className="mt-2 rounded-md border border-[#EF4444]/50 bg-[#EF4444]/10 p-2.5 text-sm" data-testid={testId}>
      <p className="flex items-center gap-2 font-semibold text-[#B91C1C] mb-1.5">
        <AlertTriangle className="w-4 h-4" /> Taban yetersiz: {w.p.sole_code}{w.p.sole_color ? ` · ${w.p.sole_color}` : ""}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {w.list.map((x) => (
          <span key={x.size} className="text-[11px] font-mono px-2 py-0.5 rounded bg-[#FFFBF4] border border-[#EF4444]/40 text-[#B91C1C]" data-testid={`${testId}-${x.size}`}>
            N°{x.size}: gerekli {x.need} · mevcut {x.avail} · eksik {x.need - Math.max(x.avail, 0)}
          </span>
        ))}
      </div>
      <p className="text-[11px] text-[#6B5B4A] mt-1.5">Aynı tabanı kullanan tüm kalemlerin toplamına göre hesaplanır. Kesim yine kaydedilebilir; taban stoğu eksiye düşer.</p>
    </div>
  );
};
